import type { FaireProductEntity } from "../../entity_types/product";

export const p_qqb4p8nt2x: FaireProductEntity = {
  token: "p_qqb4p8nt2x",
  type: "product",
  name: "Extra Wide Spa Headband - Dusty Rose",
  brandToken: "b_dljmfs9o",
  brandName: "KITSCH",
  imageUrl:
    "https://cdn.faire.com/fastly/9e8afd3c6966fe5aac121443ccc9a0184907c57f69491e1034b9f03d8a6923d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d899fd241fbb55b7f0a623912c662abea839e6c712a01bb5430c826c9c8eecfc.jpeg",
    "https://cdn.faire.com/fastly/9c62fe9e080cb95cc5dd0353d972b9f44b11d3c15a615843a37859f641820bad.jpeg",
    "https://cdn.faire.com/fastly/e874c42528af3675e1fd4aa0fb0e49240c0398c869f841155ecccb30abc9289b.jpeg",
    "https://cdn.faire.com/fastly/9813e556233806c76988e7ec998a622e55925caa7ff7f3bb2c5d36f456c0c805.jpeg",
  ],
  priceDollars: 6.85,
  description:
    "Kitsch Eco-Friendly Extra Wide Spa Headband is the perfect size to hold all your hair and protect your hairline. Made of super soft, recycled material, this multitasking headband is a must-have for preserving your style and the perfect complement to your hair care routine!\n\nFeatures:\n-Extra wide, stretchy design allows you to fully tuck your hair in during wear\n-Helps to keep hair dry & clean\n-Holds your hair back during makeup or product application\n-Perfect addition to your daily skin care ritual and provides full hairline coverage while washing your face, bathing, during facials, at the spa or sauna\n-Material is soft & comfy, bringing the luxury of the spa into your home",
  tags: [],
  msrpDollars: 13.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:48.784Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
